import React, { useEffect, useRef } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { useTypedSelector } from "../../hooks";
import { getSelectedConversationExchanges } from "../../store/conversation.tsx";

interface ConversationProps {
  children?: React.ReactNode;
}

const Conversation: React.FC<ConversationProps> = ({ children }) => {
  const exchanges = useTypedSelector(
    (state) =>
      getSelectedConversationExchanges(state) || { byId: {}, allIds: [] },
  );
  // Create a ref for the container element
  const containerRef = useRef<HTMLDivElement>(null);

  const theme = useTheme();

  // Function to scroll to the bottom with animation
  const scrollToBottom = () => {
    if (containerRef.current) {
      const scrollHeight = containerRef.current.scrollHeight;
      const scrollTop = containerRef.current.scrollTop;
      const clientHeight = containerRef.current.clientHeight;
      const isAtBottom = scrollHeight - scrollTop === clientHeight;

      if (!isAtBottom) {
        containerRef.current.scrollTo({
          top: scrollHeight,
          behavior: "smooth", // Animate the scroll
        });
      }
    }
  };

  // Scroll the container to the bottom whenever content changes
  useEffect(() => {
    if (containerRef.current) {
      scrollToBottom();
    }
  }, [exchanges]);

  return (
    <Box
      ref={containerRef}
      textAlign={"left"}
      paddingTop={"5%"}
      paddingRight={"5%"}
      overflow={"auto"}
      maxHeight={"80vh"}
      sx={[
        {
          transition: "scroll 0.3s ease-in-out", // Apply CSS transition for scroll
        },
        useMediaQuery(theme.breakpoints.down("sm")) && {
          maxHeight: "79vh",
        },
      ]}
    >
      {children}
    </Box>
  );
};

export default Conversation;
